import posthog from "posthog-js";

export function initPosthog(){
    posthog.init(process.env.VUE_APP_POSTHOG_API_KEY, {
        api_host: "https://eu.posthog.com",
        autocapture: false,
        capture_pageview: false,
        disable_persistence: true,
      });
}